module.exports = __webpack_public_path__ + "img/9.e20e5d6d.jpg";